// @flow

import type { Dispatch } from 'redux';

import {
    getLocalParticipant
} from '../base/participants';
import { participantsUpdate } from '../services';

import {
    SET_TOOLBOX_ENABLED,
    SET_TOOLBOX_VISIBLE,
    TOGGLE_TOOLBOX_VISIBLE
} from './actionTypes';


/**
 * Enables/disables the toolbox.
 *
 * @param {boolean} enabled - True to enable the toolbox or false to disable it.
 * @returns {{
 *     type: SET_TOOLBOX_ENABLED,
 *     enabled: boolean
 * }}
 */
export function setToolboxEnabled(enabled: boolean): Object {
    return {
        type: SET_TOOLBOX_ENABLED,
        enabled
    };
}

/**
 * Shows/hides the toolbox.
 *
 * @param {boolean} visible - True to show the toolbox or false to hide it.
 * @returns {Function}
 */
export function setToolboxVisible(visible: boolean): Object {
    return (dispatch: Dispatch<any>, getState: Function) => {
        const { toolbarConfig: { alwaysVisible } } = getState()['features/base/config'];

        if (!visible && alwaysVisible) {
            return;
        }

        dispatch({
            type: SET_TOOLBOX_VISIBLE,
            visible
        });
    };
}


/**
 * 
 * @param {*} visible
 * @returns
 */
export function participantsLeftMetting(visible: boolean): Object {
    return (dispatch: Dispatch<any>, getState: Function) => {
        const state = getState();
        const { faceExpressionsBuffer } = state['features/face-landmarks'];
        const { jwt } = state['features/base/jwt'];
        const { event, participantID } = state['features/base/conference'];
        const { local } = state['features/base/participants'];
        const { email } = getLocalParticipant(state);
        const formData = new FormData();

        const dateObject = new Date();
        const currentDateTime = dateObject.toISOString();

        formData.append('event_id', event.id);
        formData.append('role_id', 1);
        formData.append('email', email ? email : 'sample@something.com');
        formData.append('username', local.name);
        formData.append('is_deleted', false);
        formData.append('left_at', currentDateTime);
        formData.append('emotions', JSON.stringify(faceExpressionsBuffer));
        formData.append('is_moderator', Boolean(jwt));
        participantsUpdate(participantID, formData);
    };
}

/**
 * Action to toggle the toolbox visibility.
 *
 * @returns {Function}
 */
export function toggleToolboxVisible() {
    return (dispatch: Dispatch<any>, getState: Function) => {
        const state = getState();
        const { toolbarConfig: { alwaysVisible } } = state['features/base/config'];
        const { visible } = state['features/toolbox'];

        if (visible && alwaysVisible) {
            return;
        }

        dispatch({
            type: TOGGLE_TOOLBOX_VISIBLE
        });
    };
}
